<div class="advisory-container">

    <!-- Banner Section -->
    <section class="advisory-banner">

        <div class="banner-container">

            <div class="banner-content">
                <p class="heading">
                    Expert HR Advisory
                    Services for Business
                    Success
                </p>
                <p class="description">
                    Your people are the backbone of your business, and having the
                    correct HR strategy in place may make all the difference.
                </p>
                <button class="btn-experts" (click)="scrollToId('contact-section')">
                    <p>Get Free Consultation</p>
                    <img src="../../../../../assets/images/hr-advisory/arrow-right.svg">
                </button>
            </div>
            <div class="banner-img">
                <img src="../../../../../assets/images/hr-advisory/banner-img.png">
            </div>

        </div>
    </section>
    <div class="banner-bottom-img">
        <div class="top"></div>
        <img src="../../../../../assets/images/hr-advisory/banner-pattern.svg">
    </div>

    <!-- advisory intro section -->
    <section class="advisory-intro">
        <div class="intro-container">
            <div class="intro-img">
                <img src="../../../../../assets/images/hr-advisory/intro-img.png">
            </div>
            <div class="intro-content">
                <p class="heading">HR Advisory Services</p>
                <div class="descriptions">
                    <p class="description">
                        At Worknigeria, our HR Advisory Services are designed to aid
                        organizations, especially SMEs, in establishing successful people
                        strategies that drive growth and success.
                    </p>
                    <p class="description">
                        Whether you're expanding to a new specialty, planning your workforce
                        needs, or refining HR operations, we're here to support you every step of
                        the way.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <!-- advisory services section -->
    <section class="advisory-services">
        <div class="services-container">
            <div class="headings">
                <p class="title">
                    HR Advisory <span>Services</span>
                </p>
                <p class="description limit-description">
                    Whether you're expanding to a new specialty, planning your workforce needs, or refining HR
                    operations, we're here to support you every step of the way.
                </p>
            </div>
            <div class="services-cards">
                <div class="services-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/hr-advisory/people-1.svg">
                    </div>
                    <p class="card-title">People-First Approach</p>
                    <p class="card-description">
                        We understand that your team is your greatest
                        asset
                    </p>
                </div>
                <div class="services-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/hr-advisory/circles-1.svg">
                    </div>
                    <p class="card-title">Strategic Planning</p>
                    <p class="card-description">
                        Align your HR strategy with business objectives
                    </p>
                </div>
                <div class="services-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/hr-advisory/graph-up-1.svg">
                    </div>
                    <p class="card-title">Growth Focused</p>
                    <p class="card-description">
                        Scale your workforce efficiently as you grow
                    </p>
                </div>
            </div>
        </div>
    </section>


    <!-- offering section -->
    <section class="advisory-offering">
        <div class="offering-container">
            <p class="title">
                What We Offer
            </p>
            <div class="offering-cards">
                <div class="offering-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/hr-advisory/people-2.svg">
                    </div>
                    <p class="card-title">Workforce Planning</p>
                    <p class="card-description">
                        Determine the correct number and mix of
                        personnel to achieve your present and future
                        business goals.
                    </p>
                </div>
                <div class="offering-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/hr-advisory/circles-2.svg">
                    </div>
                    <p class="card-title">HR Strategy Development</p>
                    <p class="card-description">
                        Build bespoke HR plans in line with your
                        business objectives.
                    </p>
                </div>
                <div class="offering-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/hr-advisory/graph-up-2.svg">
                    </div>
                    <p class="card-title">Niche Expansion Support</p>
                    <p class="card-description">
                        Transition your business into a new industry
                        with expert advice on structuring your team.
                    </p>
                </div>
                <div class="offering-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/hr-advisory/heart.svg">
                    </div>
                    <p class="card-title">Employee Engagement Programs</p>
                    <p class="card-description">
                        Increase productivity and morale with
                        tailored techniques.
                    </p>
                </div>
                <div class="offering-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/hr-advisory/gear.svg">
                    </div>
                    <p class="card-title">Process Optimization</p>
                    <p class="card-description">
                        Streamline your HR operations to save time
                        and resources.
                    </p>
                </div>
                <div class="offering-card">
                    <div class="card-icon">
                        <img src="../../../../../assets/images/hr-advisory/dollar.svg">
                    </div>
                    <p class="card-title">Cost-Effective Solutions</p>
                    <p class="card-description">
                        Achieve your HR goals without
                        overspending.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <!-- choose us section -->
    <section class="advisory-choose-us">
        <div class="choose-us-container">
            <div class="left-container">
                <div class="pill">
                    <p>Why Us</p>
                </div>
                <p class="title">
                    Why Choose <span>WorkNigeria?</span>
                </p>
                <p class="description">
                    With years of experience working with businesses of all sizes, our staff knows the problems and
                    opportunities you face. We deliver unique, effective solutions that help companies reduce turnover,
                    boost employee happiness, and establish a flourishing team.
                </p>
                <div class="cards">
                    <div class="card">
                        <div class="card-icon">
                            <img src="../../../../../assets/images/hr-advisory/badge.svg">
                        </div>
                        <div class="card-content">
                            <p class="card-title">
                                Years of Experience
                            </p>
                            <p class="card-description">
                                Working with businesses of all sizes across various industries
                            </p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-icon">
                            <img src="../../../../../assets/images/hr-advisory/graph-down.svg">
                        </div>
                        <div class="card-content">
                            <p class="card-title">
                                Reduce Turnover
                            </p>
                            <p class="card-description">
                                Implement strategies that keep your best talent engaged
                            </p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-icon">
                            <img src="../../../../../assets/images/hr-advisory/people-3.svg">
                        </div>
                        <div class="card-content">
                            <p class="card-title">
                                Boost Employee Happiness
                            </p>
                            <p class="card-description">
                                Create a workplace culture that attracts and retains talent
                            </p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-icon">
                            <img src="../../../../../assets/images/hr-advisory/check-circle.svg">
                        </div>
                        <div class="card-content">
                            <p class="card-title">
                                Unique Solutions
                            </p>
                            <p class="card-description">
                                Tailored approaches that fit your specific business needs
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-container">
                <img src="../../../../../assets/images/hr-advisory/choose-us-img.png">
                <div class="box">
                    <p class="description">
                        Don't leave your HR strategy to chance. Let WorkNigeria help you
                        unlock your team's full potential.
                    </p>
                    <p class="title">Let's Transform Your Workforce</p>
                </div>
            </div>
        </div>
    </section>

    <!-- contact us section -->
    <section id="contact-section" class="advisory-contact">
        <div class="contact-container">
            <div class="headings">
                <p class="title">Get A Free Consultation</p>
                <p class="description">
                    Access free expert advice to improve your HR strategy. Complete the form to begin.
                </p>
            </div>
            <div class="contact-row">
                <div class="contact-left">
                    <form [formGroup]="consultationForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <p class="field">Name</p>
                            <input type="text" required formControlName="name" placeholder="Enter your full name">
                        </div>
                        <div class="form-group">
                            <p class="field">Email</p>
                            <input type="email" required formControlName="email" placeholder="Enter your email address">
                        </div>

                        <div class="form-group">
                            <p class="field">Phone Number</p>
                            <input type="tel" required formControlName="phone" placeholder="Enter your phone number">
                        </div>

                        <button type="submit" class="btn-submit">
                            <p class="btn-text">Submit</p>
                            <img src="../../../../../assets/images/background-check/send.svg">
                        </button>
                    </form>
                </div>
                <div class="contact-right">
                    <div class="headings">
                        <p class="title">
                            Our Contact Details
                        </p>
                        <p class="description">
                            Get in touch with us today and let's discuss how we can help transform
                            your workforce.
                        </p>
                    </div>
                    <div class="contact-info">
                        <div class="contact-item">
                            <div class="item-icon">
                                <img src="../../../../../assets/images/hr-advisory/email.svg">
                            </div>
                            <div class="item-content">
                                <p class="title">Email</p>
                                <p class="description">helpdesk@worknigeria.com</p>
                            </div>
                        </div>
                        <div class="contact-item">
                            <div class="item-icon">
                                <img src="../../../../../assets/images/hr-advisory/phone.svg">
                            </div>
                            <div class="item-content">
                                <p class="title">Phone</p>
                                <p class="description">+2349137000206</p>
                            </div>
                        </div>
                        <div class="contact-item">
                            <div class="item-icon">
                                <img src="../../../../../assets/images/hr-advisory/location.svg">
                            </div>
                            <div class="item-content">
                                <p class="title">Location</p>
                                <p class="description">Ikeja GRA, Lagos, Nigeria</p>
                            </div>
                        </div>
                    </div>
                    <div class="timings">
                        <p class="title">Business Hours</p>
                        <p>Monday - Friday: 9:00 AM - 5:00 PM</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>